function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function message(msg, actual) {
  for (var _len = arguments.length, types = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    types[_key - 2] = arguments[_key];
  }
  types = types.filter(Boolean);
  if (types.length > 2) {
    var last = types.pop();
    msg += "one of type ".concat(types.join(', '), ", or ").concat(last, ".");
  } else if (types.length === 2) {
    msg += "one of type ".concat(types[0], " or ").concat(types[1], ".");
  } else {
    msg += "of type ".concat(types[0], ".");
  }
  if (actual == null) {
    msg += " Received ".concat(actual);
  } else if (typeof actual === 'function' && actual.name) {
    msg += " Received function ".concat(actual.name);
  } else if (_typeof(actual) === 'object' && actual != null) {
    var _actual$constructor;
    if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== void 0 && _actual$constructor.name) {
      msg += " Received an instance of ".concat(actual.constructor.name);
    }
  }
  return msg;
}
export default (function (actual) {
  for (var _len2 = arguments.length, types = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    types[_key2 - 1] = arguments[_key2];
  }
  return message.apply(void 0, ['Key must be ', actual].concat(types));
});
export function withAlg(alg, actual) {
  for (var _len3 = arguments.length, types = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    types[_key3 - 2] = arguments[_key3];
  }
  return message.apply(void 0, ["Key for the ".concat(alg, " algorithm must be "), actual].concat(types));
}